import { Capacitor } from '@capacitor/core';

import { AppType } from '../constants';

export function getAppType() {
  if (typeof window === 'undefined') return AppType.ADMIN;

  const { hostname } = window.location;
  const subdomain = hostname.split('.')[0].toLowerCase();

  const isNative = Capacitor.isNativePlatform();

  if (isNative || subdomain.includes('sales')) {
    return AppType.SALES;
  }

  return AppType.ADMIN;
}

export function isSalesApp() {
  const appType = getAppType();
  return appType === AppType.SALES;
}
